import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { authFetch } from "../../lib/api"
import { useAuth } from "../../context/AuthContext"

const SUMMARY = [
  { key: "searches", label: "Saved searches", to: "/dashboard/saved-searches", icon: "fa-solid fa-magnifying-glass-location" },
  { key: "homes", label: "Saved homes", to: "/dashboard/saved-homes", icon: "fa-solid fa-heart" },
  { key: "applications", label: "Applications", to: "/dashboard/applications", icon: "fa-solid fa-file-signature" },
  { key: "bookings", label: "Bookings", to: "/dashboard/bookings", icon: "fa-solid fa-calendar-check" },
]

export default function DashboardHome() {
  const { user } = useAuth()
  const [counts, setCounts] = useState({ searches: 0, homes: 0, applications: 0, bookings: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    Promise.all([
      authFetch("/api/saved-searches").then((r) => r.json()),
      authFetch("/api/saved-homes").then((r) => r.json()),
      authFetch("/api/rental-applications").then((r) => r.json()),
      authFetch("/api/bookings").then((r) => r.json()),
    ])
      .then(([s, h, a, b]) => {
        if (cancelled) return
        setCounts({
          searches: (s.savedSearches || []).length,
          homes: (h.savedHomes || []).length,
          applications: (a.rentalApplications || []).length,
          bookings: (b.bookings || []).length,
        })
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className='dashboard-stack'>
      <section className='dashboard-welcome'>
        <div>
          <span className='dashboard-eyebrow'>Welcome back</span>
          <h2>{user?.name ? `Hi, ${user.name.split(" ")[0]}` : "Your Vista Hill workspace"}</h2>
          <p>
            Keep your favorite homes, tours, and applications moving without losing track of
            the details.
          </p>
        </div>
        <Link to='/listings' className='dashboard-primary-action'>
          <i className='fa-solid fa-house'></i>
          Browse listings
        </Link>
      </section>

      <section className='dashboard-summary' aria-label='Account summary'>
        {SUMMARY.map((item) => (
          <Link to={item.to} className='dashboard-summary__item' key={item.key}>
            <span className='dashboard-summary__icon'>
              <i className={item.icon}></i>
            </span>
            <span>{item.label}</span>
            <strong>{loading ? "-" : counts[item.key]}</strong>
          </Link>
        ))}
      </section>

      <section className='dashboard-two-column'>
        <div className='dashboard-card'>
          <div className='dashboard-card__header'>
            <div>
              <span className='dashboard-eyebrow'>Next steps</span>
              <h2>Continue your home search</h2>
            </div>
          </div>
          <div className='dashboard-action-list'>
            <Link to='/dashboard/saved-homes'>
              <i className='fa-solid fa-heart'></i>
              <span>
                <strong>Review saved homes</strong>
                <small>Compare your shortlist and reopen property details.</small>
              </span>
            </Link>
            <Link to='/dashboard/bookings'>
              <i className='fa-solid fa-calendar-days'></i>
              <span>
                <strong>Check upcoming bookings</strong>
                <small>Track pending or confirmed tours and stays.</small>
              </span>
            </Link>
            <Link to='/contact'>
              <i className='fa-solid fa-comments'></i>
              <span>
                <strong>Talk to Vista Hill</strong>
                <small>Ask about custom builds, tours, or property fit.</small>
              </span>
            </Link>
          </div>
        </div>

        <div className='dashboard-card dashboard-service-card'>
          <span className='dashboard-eyebrow'>Design and build</span>
          <h2>Want something built around you?</h2>
          <p>
            If listings do not match your lifestyle, start a custom build conversation and
            let the team help shape a home from site to handover.
          </p>
          <Link to='/pricing'>Explore services</Link>
        </div>
      </section>
    </div>
  )
}
